module.exports = __webpack_public_path__ + "images/emoji/bust_in_silhouette.f27615cc0db5c22d6484.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bust_in_silhouette.png
// module id = nH9E
// module chunks = 2